import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'get'

export default class OspreyOffersMetadata extends BaseAction {
    constructor() {
        const id = 'c3fcb7a9-5bb2-4e60-9405-a293f76434ea'
        const path = `/${resource}/metadata`
        super(resource, verb, path, id)
        this.noCache = true
    }

    getMetadata(fields) {
        if (!fields) {
            fields = ['base', 'offer' ]
        }

        if (Array.isArray(fields)) {
            fields = fields.join(',')
        }

        this.params = {
            fields
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-metadata.js